import React, { useContext } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SidebarThemeContext from '../../../../@coremat/CmtLayouts/SidebarThemeContext/SidebarThemeContext';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '30px 16px 12px 16px',
    borderBottom: props => `solid 1px ${props.sidebarTheme.borderColor}`,
  },
  logo: {
    maxWidth: 200,
    maxHeight: 50,
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
  },
}));

const SidebarHeader = () => {
  const { sidebarTheme } = useContext(SidebarThemeContext);
  const classes = useStyles({ sidebarTheme });

  return (
    <div className={classes.root}>
      <img src="/images/logo-white.png" alt="Shimanto Bank" className={classes.logo} />
    </div>
  );
};

export default SidebarHeader;
